module.exports = __webpack_public_path__ + "img/posologie-vide.efc1ea21.png";